import React from 'react';
import { getMyMusicianAvailability, updateMyMusicianAvailability } from '../lib/api';
import AvailabilityPage from '../components/AvailabilityPage';

export default function MusicianAvailabilityPage() {
  return (
    <AvailabilityPage
      getAvailability={getMyMusicianAvailability}
      updateAvailability={updateMyMusicianAvailability}
      backTo="/musicians/me"
    />
  );
}
